<template>
  <div class="event-detail">
    <template v-if="hasData">
      <div class="event-detail__title">詳細資訊</div>

      <table class="event-detail__table">
        <tbody>
          <tr v-if="row.i3 !== null">
            <td class="event-detail__label">最大3小時平均降雨 (7日內)</td>
            <td class="event-detail__value">{{ row.i3.toFixed(3) }} mm/hr</td>
          </tr>
          <tr v-if="row.r24 !== null">
            <td class="event-detail__label">最大24小時累積雨量 (7日內)</td>
            <td class="event-detail__value">{{ row.r24.toFixed(1) }} mm</td>
          </tr>
          <tr v-if="row.wsl !== null">
            <td class="event-detail__label">行動值</td>
            <td class="event-detail__value">{{ formatWsl }}</td>
          </tr>
          <tr v-if="row.al !== null">
            <td class="event-detail__label">警戒值</td>
            <td class="event-detail__value">{{ formatAl }}</td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="row.relatedAnomalyProbeNames && row.relatedAnomalyProbeNames.length > 0"
        class="event-detail__probes"
      >
        <div class="event-detail__probes-title">
          同時異常儀器 ({{ row.relatedAnomalyProbeNames.length }})
        </div>
        <div class="event-detail__probes-list">
          <div
            v-for="(name, idx) in row.relatedAnomalyProbeNames"
            :key="idx"
            class="event-detail__probe-tag"
          >
            {{ name }}
          </div>
        </div>
      </div>
    </template>

    <div v-else class="event-detail__empty">
      無詳細資料
    </div>
  </div>
</template>

<script>
import { getUnit } from '@/utils/formatters';

export default {
  name: 'EventDetailPopover',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasData() {
      return (
        this.row.i3 !== null ||
        this.row.r24 !== null ||
        this.row.wsl !== null ||
        this.row.al !== null ||
        (this.row.relatedAnomalyProbeNames && this.row.relatedAnomalyProbeNames.length > 0)
      );
    },
    formatWsl() {
      if (this.row.wsl === null || this.row.wsl === undefined) return '';
      const unit = getUnit(this.row.probeName);
      return `${this.row.wsl.toFixed(3)} ${unit}`.trim();
    },
    formatAl() {
      if (this.row.al === null || this.row.al === undefined) return '';
      const unit = getUnit(this.row.probeName);
      return `${this.row.al.toFixed(3)} ${unit}`.trim();
    },
  },
};
</script>

<style scoped>
.event-detail {
  padding: 4px;
  min-width: 220px;
}

.event-detail__title {
  font-size: 15px;
  font-weight: 600;
  color: #e6a23c;
  border-bottom: 1px solid #4a4a4a;
  padding-bottom: 8px;
  margin-bottom: 10px;
}

.event-detail__table {
  width: 100%;
  text-align: left;
}

.event-detail__table td {
  padding: 4px 0;
  font-size: 13px;
}

.event-detail__label {
  color: #909399;
  padding-right: 16px;
  white-space: nowrap;
}

.event-detail__value {
  color: #303133;
  font-weight: 500;
}

.event-detail__probes {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.event-detail__probes-title {
  color: #909399;
  font-size: 13px;
  margin-bottom: 8px;
}

.event-detail__probes-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.event-detail__probe-tag {
  font-size: 12px;
  color: #409eff;
  background-color: #ecf5ff;
  padding: 3px 8px;
  border-radius: 3px;
}

.event-detail__empty {
  color: #c0c4cc;
  font-style: italic;
  font-size: 13px;
}
</style>